import { render, staticRenderFns } from "./OrmBatchingNewModal.vue?vue&type=template&id=2cbe1bf8"
import script from "./OrmBatchingNewModal.vue?vue&type=script&lang=js"
export * from "./OrmBatchingNewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cbe1bf8')) {
      api.createRecord('2cbe1bf8', component.options)
    } else {
      api.reload('2cbe1bf8', component.options)
    }
    module.hot.accept("./OrmBatchingNewModal.vue?vue&type=template&id=2cbe1bf8", function () {
      api.rerender('2cbe1bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingNewModal.vue"
export default component.exports